import React from 'react'
import cn from 'clsx'
import LayoutWrapper, {
  LayoutProps,
} from '@components/Common/Layout/LayoutWrapper'

const Layout: React.FC<LayoutProps> = ({ children, ...props }) => {
  return (
    <LayoutWrapper {...props}>
      <main
        className={cn('fit flex-1 relative overflow-x-hidden ', {
          'py-3 md:py-6': props.variant !== 'NoPadding',
           'overflow-y-auto': props.noScroll ===  false,
          'overflow-y-hidden': props.noScroll === true,
        })}
      >
        {children}
      </main>
    </LayoutWrapper>
  )
}
export default Layout
